import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { ramsAOptions, ramsCOptions, ramsEcOptions, ramsEnvOptions, ramsPOptions, ramsROptions, ramsSOptions } from '../../../utils/data/rams';
import * as htmlHelper from '../../../utils/htmlHelper';
import { DataPanel, PanelSection, PanelTable, TableBody, TableData, TableRow } from '../../elements';
import { AssetsViewer } from '../Common/AssetsViewer';
import { RamsItem } from '../Common/RamsItem';
import { IFailureMode } from '../Interfaces/IFailureMode';

interface IConditionReportFmecaVerificationProps extends ITranslateProps {
    failureMode: IFailureMode;
    isAssetDescriptionVisible: boolean;
    surveyId: string;
}

class ConditionReportFmecaVerificationComponent extends React.Component<IConditionReportFmecaVerificationProps, Record<string, unknown>> {
    constructor(props: IConditionReportFmecaVerificationProps) {
        super(props);
    }

    public override render() {
        return (
            <DataPanel>
                <PanelSection>
                    <RamsItem
                        topLetter="R"
                        ramsScore={this.props.failureMode.verificationRamsR}
                        ramsOptions={ramsROptions}
                        header="Betrouwbaarheid"
                    />
                    <RamsItem
                        topLetter="A"
                        ramsScore={this.props.failureMode.verificationRamsA}
                        ramsOptions={ramsAOptions}
                        header="Beschikbaarheid"
                    />
                    <RamsItem topLetter="S" ramsScore={this.props.failureMode.verificationRamsS} ramsOptions={ramsSOptions} header="Veiligheid" />
                    <RamsItem
                        topLetter="C"
                        ramsScore={this.props.failureMode.verificationRamsC}
                        ramsOptions={ramsCOptions}
                        header="Verzorgingsniveau"
                    />
                    <RamsItem topLetter="E" ramsScore={this.props.failureMode.verificationRamsEc} ramsOptions={ramsEcOptions} header="Gevolgkosten" />
                    <RamsItem topLetter="E" ramsScore={this.props.failureMode.verificationRamsEnv} ramsOptions={ramsEnvOptions} header="Milieu" />
                    <RamsItem topLetter="P" ramsScore={this.props.failureMode.verificationRamsP} ramsOptions={ramsPOptions} header="Imago" />
                </PanelSection>
                {this.props.failureMode.verificationRemarks && (
                    <PanelSection>{htmlHelper.newLineToBreak(this.props.failureMode.verificationRemarks)}</PanelSection>
                )}
                {this.props.failureMode.findings && this.props.failureMode.findings.length > 0 && (
                    <div className="row p10 mr20">
                        <h5>{this.props.t('failureMode.findings')}</h5>
                        <PanelTable>
                            <TableBody>
                                {this.props.failureMode.findings.map((finding) => (
                                    <TableRow key={finding.id}>
                                        <TableData>{finding.description} </TableData>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </PanelTable>
                    </div>
                )}

                <div className="row mt10">
                    {this.props.failureMode.assets && (
                        <div className="p10">
                            <AssetsViewer assets={this.props.failureMode.assets} surveyId={this.props.surveyId} />
                        </div>
                    )}
                </div>
            </DataPanel>
        );
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ConditionReportFMECAVerification = translate()(ConditionReportFmecaVerificationComponent);
